import { Box, Button, Icon, MenuItem, MenuList, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { differenceInDays, eachMonthOfInterval, eachWeekOfInterval, formatISO } from 'date-fns';
import { ReactElement } from 'react';
import { formatInterval } from 'utilities';
import { Interval } from '../types';
import { allowedPlacements } from 'components/Actions/DropdownActions';

export function GapRow({
  interval,
  onInsert,
}: {
  interval: Interval;
  onInsert: (split: 'full' | 'month' | 'week') => void;
}): ReactElement | null {
  const days = differenceInDays(interval.end, interval.start) + 1;
  const months = eachMonthOfInterval(interval).length;
  const weeks = eachWeekOfInterval(interval, { weekStartsOn: 1 }).length;

  return (
    <Box display="flex" alignItems="center" textSize="sm">
      <PopoverRoot>
        <PopoverTrigger>
          <Button
            variant="ghost"
            size="xs"
            icon="circle-plus"
            testId="add-position"
            data-start={formatISO(interval.start, { representation: 'date' })}
            data-end={formatISO(interval.end, { representation: 'date' })}
          >
            {formatInterval(interval.start, interval.end)}
          </Button>
        </PopoverTrigger>
        <PopoverPopup closeOnContentClick placementOptions={{ allowedPlacements }}>
          <MenuList>
            <MenuItem
              label="Full period"
              testId="action-full"
              prefix={<Icon icon="calendar-range" />}
              onClick={() => onInsert('full')}
              suffix={
                <Box textSize="xs" color="disabled">
                  {days}d
                </Box>
              }
            />
            {months > 1 && (
              <MenuItem
                label="By month"
                testId="action-split-month"
                prefix={<Icon icon="calendar" />}
                onClick={() => onInsert('month')}
                suffix={
                  <Box textSize="xs" color="disabled">
                    {months}m
                  </Box>
                }
              />
            )}
            {weeks > 1 && (
              <MenuItem
                label="By week"
                testId="action-split-week"
                prefix={<Icon icon="calendar-week" />}
                onClick={() => onInsert('week')}
                suffix={
                  <Box textSize="xs" color="disabled">
                    {weeks}w
                  </Box>
                }
              />
            )}
          </MenuList>
        </PopoverPopup>
      </PopoverRoot>
    </Box>
  );
}
